@use "../../../assets/styles/abstracts/variables" as v;
@use "../../../assets/styles/abstracts/mixins/typography" as t;

.emailVerificationWrapper {
    width: 100%;
    padding: 40px 16px;
    border-radius: 16px;
    border: 2px solid v.$gray-border-panel-color;
    background: v.$gradient-form-card;
    backdrop-filter: blur(1px);
  
    @media (min-width: 768px) {
      padding: 40px;
      max-width: 440px;
      margin: 0 auto;
    }
}

.emailVerificationTitle {
    @include t.text(36px, 48px, "bold");
    color: v.$white-color;
    margin-bottom: 8px;
}

.emailVerificationDescription {
    color: v.$gray-light-color;
    @include t.text(14px, 22px, "normal");
    margin-bottom: 16px;
}

.formButton {
    cursor: pointer;
    width: 100%;
    display: flex;
    height: 48px;
    padding: 8px 24px;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    background: v.$green-color;
    @include t.text(16px, 26px, "semi-bold");
    color: v.$white-color;
}

/* Chinese Brothers */

.emailVerificationWrapperChineseBrothers {
  border: 1px solid v.$chinese-brothers-border-color;
  background: v.$chinese-brothers-card-bg;
}

.formButtonChineseBrothers {
  background: v.$white-color;
  color: v.$navy-dark-color-2;
}